package com.shmbles.web.sections

import androidx.compose.runtime.Composable
import com.shmbles.web.components.Header
import com.shmbles.web.components.SocialBar
import com.shmbles.web.models.Section
import com.shmbles.web.models.Theme
import com.shmbles.web.styles.MainButtonStyle
import com.shmbles.web.styles.MainImageStyle
import com.shmbles.web.util.Constants.FONT_FAMILY
import com.shmbles.web.util.Constants.LINKEDIN
import com.shmbles.web.util.Constants.RESUME
import com.shmbles.web.util.Constants.SECTION_WIDTH
import com.shmbles.web.util.Res
import com.varabyte.kobweb.navigation.OpenLinkStrategy
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun MainSection(onMenuClicked: () -> Unit) {
    val breakpoint = rememberBreakpoint()
    Box(
        modifier = Modifier
            .id(Section.Home.id)
            .maxWidth(SECTION_WIDTH.px)
            .fillMaxWidth(),
        contentAlignment = Alignment.TopCenter
    ) {
        MainBackground()
        MainContent(breakpoint = breakpoint, onMenuClicked = onMenuClicked)
    }
}

@Composable
fun MainBackground() {
    Image(
        modifier = Modifier.fillMaxSize().objectFit(ObjectFit.Cover),
        src = Res.Image.background,
        description = "Background Image"
    )
}

@Composable
fun MainContent(breakpoint: Breakpoint, onMenuClicked: () -> Unit) {
    Column(
        modifier = Modifier.fillMaxSize(),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.SpaceBetween
    ) {
        Header(onMenuClicked = onMenuClicked)
        Column(
            modifier = Modifier.fillMaxSize().padding(bottom = if (breakpoint > Breakpoint.MD) 0.px else 40.px),
            verticalArrangement = Arrangement.Bottom,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            SimpleGrid(
                modifier = Modifier.fillMaxWidth(
                    if (breakpoint >= Breakpoint.MD) 80.percent else 90.percent
                ),
                numColumns = numColumns(base = 1, md = 2)
            ) {
                MainText(breakpoint = breakpoint)
                MainImage(breakpoint = breakpoint)
            }
        }
    }
}

@Composable
fun MainText(breakpoint: Breakpoint) {
    Row(
        modifier = Modifier.fillMaxWidth(),
        horizontalArrangement = if (breakpoint > Breakpoint.MD) Arrangement.Start else Arrangement.Center,
        verticalAlignment = Alignment.CenterVertically
    ) {
        Box(modifier = Modifier.displayIfAtLeast(Breakpoint.MD)) {
            SocialBar()
        }
        Column(
            modifier = Modifier.fillMaxWidth(),
            horizontalAlignment = if (breakpoint > Breakpoint.MD) Alignment.Start else Alignment.CenterHorizontally
        ) {
            P(
                attrs = Modifier
                    .margin(topBottom = 0.px)
                    .fontFamily(FONT_FAMILY)
                    .fontSize(if (breakpoint >= Breakpoint.LG) 45.px else if (breakpoint >= Breakpoint.MD) 30.px else 22.px)
                    .fontWeight(FontWeight.Normal)
                    .color(Theme.Primary.rgb)
                    .toAttrs()
            ) {
                Text("Hello, I'm")
            }
            P(
                attrs = Modifier
                    .margin(top = 10.px, bottom = 0.px)
                    .fontFamily(FONT_FAMILY)
                    .fontSize(if (breakpoint >= Breakpoint.LG) 68.px else if (breakpoint >= Breakpoint.MD) 48.px else 36.px)
                    .fontWeight(FontWeight.Bold)
                    .color(Theme.Secondary.rgb)
                    .toAttrs()
            ) {
                Text("Andres Diaz")
            }
            P(
                attrs = Modifier
                    .margin(top = 5.px, bottom = 5.px)
                    .fontFamily(FONT_FAMILY)
                    .fontSize(if (breakpoint >= Breakpoint.MD) 20.px else 18.px)
                    .fontWeight(FontWeight.Bold)
                    .color(Theme.Secondary.rgb)
                    .toAttrs()
            ) {
                Text("Mobile Developer")
            }
            P(
                attrs = Modifier
                    .margin(bottom = 25.px)
                    .maxWidth(if (breakpoint >= Breakpoint.MD) 400.px else 100.percent)
                    .fontFamily(FONT_FAMILY)
                    .fontSize(14.px)
                    .fontStyle(FontStyle.Italic)
                    .fontWeight(FontWeight.Normal)
                    .color(Theme.Secondary.rgb)
                    .toAttrs()
            ) {
                Text(RESUME)
            }
            Button(
                attrs = MainButtonStyle.toModifier()
                    .height(40.px)
                    .border(width = 0.px)
                    .borderRadius(r = 5.px)
                    .background(Theme.Primary.rgb)
                    .color(Colors.White)
                    .cursor(Cursor.Pointer)
                    .toAttrs()
            ) {
                Link(
                    modifier = Modifier.color(Colors.White).textDecorationLine(TextDecorationLine.None),
                    text = "Hire me",
                    path = LINKEDIN,
                    openExternalLinksStrategy = OpenLinkStrategy.IN_NEW_TAB
                )
            }
        }
    }
}

@Composable
fun MainImage(breakpoint: Breakpoint) {
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .padding(top = if (breakpoint > Breakpoint.MD) 0.px else 30.px),
        verticalArrangement = Arrangement.Bottom,
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Image(
            modifier = MainImageStyle.toModifier()
                .fillMaxWidth(if (breakpoint >= Breakpoint.MD) 90.percent else 70.percent)
                .maxWidth(if (breakpoint >= Breakpoint.MD) 500.px else 300.px),
            src = Res.Image.main,
            description = "Main Image"
        )
    }
}